/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Changesdiscarded1Inputs */

const en_changesdiscarded1 = /** @type {(inputs: Changesdiscarded1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changes discarded`)
};

const de_changesdiscarded1 = /** @type {(inputs: Changesdiscarded1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Änderungen verworfen`)
};

/**
* | output |
* | --- |
* | "Changes discarded" |
*
* @param {Changesdiscarded1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const changesdiscarded1 = /** @type {((inputs?: Changesdiscarded1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Changesdiscarded1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_changesdiscarded1(inputs)
	return de_changesdiscarded1(inputs)
});
export { changesdiscarded1 as "changesDiscarded" }